import { ref, computed } from "vue";

// Compteur global d'instances cfl-flyout-menu ouvertes.
// Permet d'afficher un unique backdrop tant qu'au moins un flyout est ouvert,
// même quand on passe rapidement d'un item à l'autre (pas de fouc).
const openCount = ref<number>(0);

export default function useFlyoutBackdrop()
{
	return {
		register: () =>
		{
			openCount.value++;
		},
		unregister: () =>
		{
			openCount.value = Math.max(0, openCount.value - 1);
		},
		isAnyFlyoutOpen: computed<boolean>(() => openCount.value > 0),
	};
}
